<template>
    <v-container fluid>
        <h4>{{ $t('metadata_for', { title: record.title }) }}</h4>
        <table class="stripe-table mt-2 tgk-paragraph-text">
            <tbody>
                <tr>
                    <td>{{ $t('rec_id') }}</td>
                    <td>
                        <span>{{ record.id }}</span> / UUID: <span>{{ record.uuid }}</span>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('created') }}</td>
                    <td>
                        {{ record.created.formatIf('dd, DD.MM.YYYY HH:mm') }}
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('creator') }}</td>
                    <td>
                        {{ record.creator }}
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('modified') }}</td>
                    <td>
                        {{ record.modified.formatIf('dd, DD.MM.YYYY HH:mm') }}
                        <span v-if="record.modifier"> / {{ record.modifier }}</span>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('pub_from') }}</td>
                    <td>
                        {{ record.publish_from.formatIf('dd, DD.MM.YYYY', '-') }}
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('pub_to') }}</td>
                    <td>
                        {{ record.publish_to.formatIf('dd, DD.MM.YYYY', '-') }}
                    </td>
                </tr>
                <tr v-if="!hideFrontendLinks">
                    <td>{{ $t('link') }}</td>
                    <td>
                        <a :href="record.detailUrl">{{ record.detailUrl }}</a>
                    </td>
                </tr>
                <tr v-if="!hideFrontendLinks">
                    <td>{{ $t('qr_code') }}</td>
                    <td>
                        <a
                            :href="apiUrl(`/magazin/linkQrCode?id=${record.id}&type=png&force_download=true`)"
                            target="_blank"
                        >
                            <img
                                :src="apiUrl(`/magazin/linkQrCode?id=${record.id}&type=svg`)"
                                width="150"
                                height="150"
                                alt="QR Code"
                            />
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </v-container>
</template>

<script>
import { apiUrl } from '@/helpers/globals';
import { Magazin } from '@/models/Magazin';
import { globalParam } from '@/helpers/globals';

export default {
    name: 'MagazinMetadata',
    props: {
        record: {
            type: Magazin,
            required: true,
        },
    },
    computed: {
        hideFrontendLinks() {
            return globalParam('magazin.hide_frontend_links');
        },
    },
    created() {
        this.apiUrl = apiUrl;
    },
};
</script>
